import React from 'react';
import Logo from '../../LogoFull';

var Header = function Header(_ref) {
  var inverted = _ref.inverted;
  return /*#__PURE__*/React.createElement("div", {
    className: "app-switcher-logo"
  }, /*#__PURE__*/React.createElement(Logo, {
    inverted: inverted
  }));
};

export default Header;